import { Route, Redirect } from 'react-router';
import { loadComponentAsync } from 'shared/utils/async-components';

import NotFoundView from 'shared/views/not-found-view/not-found-view';
import DesktopLayout from 'widget/layouts/desktop/desktop';
import MobileLayout from 'widget/layouts/mobile/mobile';
import LayoutSwitcher from 'widget/layouts/layout-switcher';

const importClassic = () => import(/* webpackChunkName: "widget/classic" */ 'widget/views/desktop/classic/classic');
const importStrip = () => import(/* webpackChunkName: "widget/strip" */ 'widget/views/desktop/strip/strip');
const importCompact = () => import(/* webpackChunkName: "widget/compact" */ 'widget/views/desktop/compact/compact');
const importMobile = () => import(/* webpackChunkName: "widget/mobile" */ 'widget/views/mobile/mobile');

export default (
  <Route path="/"
         component={LayoutSwitcher}>
    <Route path="desktop"
           component={DesktopLayout}>
      <Route path="classic"
             getComponent={loadComponentAsync(importClassic)} />
      <Route path="strip"
             getComponent={loadComponentAsync(importStrip)} />
      <Route path="compact"
             getComponent={loadComponentAsync(importCompact)} />
    </Route>
    <Route path="mobile"
           component={MobileLayout}>
      <Route path="default"
             getComponent={loadComponentAsync(importMobile)} />
    </Route>
    <Route path="/404"
           component={NotFoundView} />
    <Redirect from="*"
              to="/404" />
  </Route>
);



// WEBPACK FOOTER //
// ./src/widget/routes/index.js